<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<div class="flex">
			<h1>Styling model categories</h1>
			<div class="text-right flex-grow">
				<button v-on:click="save()" :disabled="saving">Save</button>
			</div>
		</div>
		<div class="margin-top">

			<table>
				<thead>
					<tr>
						<th>Category</th>
						<th>Styling model cat.</th>
						<th>Size mapping</th>
					</tr>
				</thead>
				<tbody>
					<template v-for="category in categories">
						<tr style="background: #f6f6f6; font-weight: 900;" v-if="!category.parent">
							<td>{{ category.name }}</td>
							<td>
								<select style="font-weight: 900;" v-model="values[category.id]">
									<option value="">[ Automatic ]</option>
									<option v-for="styling_model_category in styling_model_categories" :value="styling_model_category.id">
										{{ styling_model_category.name }}
									</option>
								</select>
							</td>
							<td>
								<select style="font-weight: 900;" v-model="size_mapping[category.id]">
									<option value="">[ Automatic ]</option>
									<option value="dress">Dress</option>
									<option value="upper">Upper</option>
									<option value="lower">Lower</option>
								</select>
							</td>
						</tr>
						<template v-for="subcategory in categories" v-if="subcategory.parent == category.id">
							<tr>
								<td style="padding-left: 40px;">{{ subcategory.name }}</td>
								<td>
									<select v-model="values[subcategory.id]">
										<option value="">[ Automatic ]</option>
										<option v-for="styling_model_category in styling_model_categories" :value="styling_model_category.id">
											{{ styling_model_category.name }}
										</option>
									</select>
								</td>
								<td>
									<select v-model="size_mapping[subcategory.id]">
										<option value="">[ Automatic ]</option>
										<option value="dress">Dress</option>
										<option value="upper">Upper</option>
										<option value="lower">Lower</option>
									</select>
								</td>
							</tr>
						</template>
					</template>

				</tbody>
			</table>

		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    loading: false,
    saving: false,
    styling_model_categories: [],
    categories: [],
    values: {},
    size_mapping: {}
  }),
  methods: {
    load () {
      Vue.$api.get('/styling-model', {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.parse(data)
      })
    },
    save () {
      Vue.$api.put('/styling-model', {
        categories: this.values,
        size_mapping: this.size_mapping
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    parse (data) {
      this.styling_model_categories = data.styling_model_categories
      this.categories = data.categories
      this.values = data.values
      this.size_mapping = data.size_mapping
    }
  },
  created () {
    this.load()
  }
}
</script>
